const galleries = document.querySelectorAll('.c-image-gallery');

const imageClickHandler = event => {
  const dialog = event.target.nextElementSibling;
  if (dialog instanceof HTMLDialogElement) {
    event.preventDefault();
    dialog.showModal();
  }
};

const dialogKeydownHandler = event => {
  if (event.key === 'Escape') {
    event.target.close();
  }
};

const dialogClickHandler = dialog => event => {
  // Click outside dialog content
  if (event.target === dialog) {
    dialog.close();
  }
};

const initGallery = gallery => {
  const links = gallery.querySelectorAll(':scope > a');
  const dialogs = gallery.querySelectorAll(':scope > dialog');

  links.forEach(link => link.addEventListener('click', imageClickHandler));
  dialogs.forEach(dialog => {
    dialog.addEventListener('keydown', dialogKeydownHandler);
    dialog.addEventListener('click', dialogClickHandler(dialog));
  });
};

galleries.forEach(initGallery);
